export default {
  body: 'HelveticaNowDisplay-Regular, -apple-system, system-ui, sans-serif',
  heading: 'HelveticaNowDisplay-Regular, -apple-system, system-ui, sans-serif',
};
